import { Button, Grid, Typography } from '@mui/material';
import { ClientDialog, ClientDialogProps } from '@/components/common/modal/ClientDialog';
import { FixedButton } from '@/components/common/button/FixedButton';
import { MobileBar } from '@/components/home/MobileBar';
import React, { FC } from 'react';

export const AutoPrintEnabledInfoDialog: FC<ClientDialogProps> = (props: ClientDialogProps) => {
  const { open, handleCloseButton, isMobile, ...other } = props;
  return (
    <ClientDialog
      open={open}
      isMobile={isMobile}
      handleCloseButton={handleCloseButton}
      label={'Особые условия доставки'}
      {...other}>
      <Grid container={true} direction={'column'} mb={isMobile ? 6 : 0} wrap={'nowrap'}>
        <Grid item={true}>
          <Typography variant={'body1'} component={'div'}>
            <ul style={{ margin: 0, paddingInlineStart: '12px' }}>
              <li>{'В этом учреждении письма распечатываются автоматически сразу после отправки.'}</li>
              <li>
                {
                  'После оплаты вы увидите только один статус — «Доставлено». Это значит, что письмо было распечатано в учреждении.'
                }
              </li>
              <li>{'После печати сотрудники проверят письмо и передадут его адресату.'}</li>
            </ul>
          </Typography>
        </Grid>
        {isMobile ? (
          <MobileBar>
            <FixedButton color={'primary'} variant={'contained'} onClick={() => handleCloseButton(open)}>
              {'Закрыть'}
            </FixedButton>
          </MobileBar>
        ) : (
          <Grid item={true} paddingTop={'11px'}>
            <Grid container={true} justifyContent={'flex-end'}>
              <Grid item={true}>
                <Button variant={'contained'} sx={{ minWidth: '176px' }} onClick={() => handleCloseButton(open)}>
                  {'Понятно'}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </ClientDialog>
  );
};
